export default function ServiceAreas() {
  const areas = [
    'West Valley City',
    'Salt Lake City',
    'Park City',
    'West Jordan',
    'South Jordan',
    'Sandy',
    'Draper',
    'Riverton',
    'Herriman',
    'Lehi',
    'American Fork',
    'Bountiful',
    'Holladay',
    'Midway',
    'Hideout',
    'Promontory'
  ];

  return (
    <section id="service-areas" className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map - Increased size significantly */}
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[500px] lg:h-[600px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48394.64857098785!2d-111.9529183!3d40.713888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87528efdfb390ae9%3A0xb91dbd9faaf9113!2sA-One%20Solid%20Surfacing!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="A-One Solid Surfacing Location - Salt Lake County Service Area"
              ></iframe>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Serving <span className="text-amber-500">Salt Lake County</span> & Beyond
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Professional <strong>countertop installation</strong> throughout Utah's Wasatch Front. We proudly serve residential and commercial clients across <strong>Salt Lake County</strong> with expert craftsmanship and premium materials.
            </p>

            {/* Areas Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {areas.map((area, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-amber-500"></i>
                  <span className="text-gray-300">{area}</span>
                </div>
              ))}
            </div>

            {/* Contact Info */}
            <div className="bg-gray-800 rounded-2xl p-6 space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-2xl text-amber-500"></i>
                <div>
                  <div className="text-sm text-gray-400">Call Us</div>
                  <a href="tel:801-706-1610" className="text-lg font-semibold hover:text-amber-500 transition-colors">
                    801-706-1610
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-2xl text-amber-500"></i>
                <div>
                  <div className="text-sm text-gray-400">Visit Us</div>
                  <a 
                    href="https://www.google.com/maps/place/A-One+Solid+Surfacing/@40.713888,-111.9529183,597m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87528efdfb390ae9:0xb91dbd9faaf9113!8m2!3d40.713888!4d-111.9529183!16s%2Fg%2F1v3dslz4!5m1!1e1?entry=tts"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg font-semibold hover:text-amber-500 transition-colors"
                  >
                    2580 Decker Lake Blvd Suite 800, West Valley City, UT 84119
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}